
import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import * as styles from "./navigation.module.scss"

const ComponentName = () => {
  const data = useStaticQuery(graphql`
    {
      headerMenu: allWpMenuItem(
        filter: {menu: {node: {name: {eq: "Header Menu"}}}}
        sort: {fields: order, order: ASC}
      ) {
        nodes {
          id
          label
          path
          cssClasses
        }
      }
      fallbackMenu: allWpMenuItem(sort: {fields: order, order: ASC}) {
        nodes {
          id
          label
          path
          cssClasses
        }
      }
    }
  `)

  const menuItems = data.headerMenu?.nodes?.length
    ? data.headerMenu.nodes
    : (data.fallbackMenu?.nodes || []);

  return (
    <div className={styles.navigation}>
      {
        menuItems.map(function (item) {
          if (item.path === "/"){
            return (
              <Link
                className={styles.navigationItem}
                activeClassName={styles.navigationItemActive}
                to={`${item.path}`}
                key={item.id}>
                {item.label}
              </Link>
            )
          } else {
            return (
              <Link
                partiallyActive={true}
                className={styles.navigationItem}
                activeClassName={styles.navigationItemActive}
                to={`${item.path}`}
                key={item.id}>
                {item.label}
              </Link>
            )
          }
        })
      }
    </div>
  )
}

export default ComponentName

